import { ref, get, update } from "firebase/database";
import { database } from "../../../../Utils/firebase";
import GetCustomersData from "../../../Comman/GetCustomersData";
import * as actionType from "../../../../context/actions";

const DeleteAssignerUserCustomerLedgerInFirebase = async (state, dispatch, customerUniqueId, ledgerId, userID, ownerUidInput) => {
    if (!ownerUidInput || !customerUniqueId || !ledgerId) return { success: false, message: "Missing required parameters." };

    try {
        const ledgerRef = ref(
            database,
            `invoiceGenerator/users/${ownerUidInput}/customers/${customerUniqueId}/paymentsReceived`
        );

        // 1️⃣ Get the current ledger array
        const snapshot = await get(ledgerRef);
        
        if (!snapshot.exists()) {
            return { success: false, message: "Ledger not found" };
        }

        let ledger = snapshot.val();

        if (!Array.isArray(ledger)) {
            return { success: false, message: "Ledger is not an array" };
        }

        // 2️⃣ Filter out the entry by id
        const updatedLedger = ledger.filter((entry) => entry.id !== ledgerId);

        // 3️⃣ Update the whole array back in Firebase
        await update(ref(database, `invoiceGenerator/users/${ownerUidInput}/customers/${customerUniqueId}`), {
            paymentsReceived: updatedLedger,
        });

        dispatch({
            type: actionType.SELECTEDCUSTOMER,
            payload: {
                ...state?.SELECTEDCUSTOMER,
                paymentsReceived: updatedLedger,
            },
        });

        // Silently update global state
        GetCustomersData(state, dispatch);

        return { success: true, message: "Ledger entry deleted successfully!" };
    } catch (error) {
        return { success: false, message: error.message || "Failed to delete ledger entry." };
    }
};

export default DeleteAssignerUserCustomerLedgerInFirebase;
